<template>
	<VInputMask
		ref="company-nif-input"
		:value="company.additionalAttributes.nif.value"
		:label="company.additionalAttributes.nif.name"
		layout="vertical"
		:tokens="{
        '#': { pattern: /\d/ },
        X: { pattern: /[\dA-Z]/ },
      }"
		mask="ES-X#######X"
		masked
		:validate-method="EsUtils.validateNIF"
		:disabled="readOnly"
	/>

	<VInputMask
		ref="company-lei-input"
		:value="company.additionalAttributes.lei.value"
		:label="company.additionalAttributes.lei.name"
		layout="vertical"
		:tokens="{
        '#': { pattern: /\d/ },
      }"
		mask="####-##-############-##"
		:validate-method="EsUtils.validateLEI"
		:disabled="readOnly"
	/>
</template>

<script>

import EsUtils from '@/core/utils/regional/EsUtils'
import Company from "@/domains/Companies/Company.js";

export default {
	name:   'ESAdditionalAttributes',

	props: {
    company: {
      type:     Company,
      required: true
    },
		readOnly: {
			type: Boolean,
			default: false,
		}
	},

	data() {
		return {
			EsUtils,
		}
	},
};
</script>

